import { useState } from 'react';
import { useTranslations } from 'use-intl';
import { Outlet } from 'react-router-dom';
import { MessageSquarePlus } from 'lucide-react';
import { FeedbackPanel } from '@/components/feedback/FeedbackPanel';

/**
 * FIN-869 (in-app-feedback F2/AC1): the onboarding routes (/join-company, /user-onboarding,
 * /onboarding-steps) render outside MainLayout — there is no Sidebar to carry the footer entry
 * — so this thin wrapper adds a floating launcher instead. Kept as its own layout component
 * (rather than editing each onboarding page) so a future onboarding route added under the same
 * <Route element={<OnboardingLayout />}> group in App.tsx gets it for free.
 */
function OnboardingLayout() {
  const t = useTranslations('consultantShell.nav');
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <>
      <Outlet />
      <button
        onClick={() => setFeedbackOpen(true)}
        aria-label={t('feedback')}
        className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full border bg-background px-4 py-2 text-sm shadow-subtle hover:bg-accent"
      >
        <MessageSquarePlus size={18} />
        <span>{t('feedback')}</span>
      </button>
      <FeedbackPanel open={feedbackOpen} onOpenChange={setFeedbackOpen} />
    </>
  );
}

export default OnboardingLayout;
